<ion-card color="primary" class="ion-no-margin ion-margin-top ion-no-padding">

  <ion-card-header class="ion-no-margin ion-no-padding">
    <ion-grid>
      <ion-row>
        <ion-col size="2" class="ion-align-items-center ion-align-self-center ion-text-left">
          <ion-button (click)="goBack.emit(true)" class="go-back-button">
            <ion-icon name="return-up-back-outline"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="10" class="ion-align-items-center ion-align-self-center ion-text-center">
          <ion-spinner *ngIf="searchInProgress === true" name="crescent" color="secondary"></ion-spinner>
          <ion-searchbar *ngIf="searchInProgress === false" (ionInput)="search($event)" debounce="500" i18n-placeholder="Cerca giocatore..." placeholder="Cerca giocatore..." autocomplete="off" autofocus="true" color="secondary" #searchPlayer></ion-searchbar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-header>

  <ion-card-content class="ion-no-padding">
    <ion-grid *ngIf="!!players && players.length > 0">
      <ion-row>
        <ion-col size="4" *ngFor="let player of players;">
          <app-player-card [player]="player" (click)="select(player)"></app-player-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>

</ion-card>

